import { ApiRequestInterceptor } from "./apiRequest";
import { FAQ } from "../constants/endpoints/endpoints";

export const fetchFaq = async () => {
    const method = "GET";
    const response = await ApiRequestInterceptor(FAQ.faq, method);
    const { code, data } = response;

    if (code === 200) {
        return { code, data };
    } else {
        throw new Error("Error al obtener datos de faq");
    }
};
